
import AppConstants from "../components/AppConstants";


export const getConfig = () => {
  const authToken = localStorage.getItem(AppConstants.JWT)
  return{ headers: {Authorization: `Token ${authToken}`,
  'Content-Type': 'application/json',
}}
}


